module.exports = __webpack_public_path__ + "d1b8df579e3e4583dea2a4756f5db30c.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-460.webp
// module id = 561
// module chunks = 0